// extracted by mini-css-extract-plugin
export default {"title":"FilterItem_title__qxO0h","col":"FilterItem_col__yGBsB"};